//REDIRECTS

const globalSite = "https://perky-pear.myshopify.com/";
const usaSite = "https://perky-pear-us.myshopify.com/";
let username = "Max Brown";

// Set a Cookie
function setCookie(cName, cValue, expDays) {
  let date = new Date();
  date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
  const expires = "expires=" + date.toUTCString();
  document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}
function getCookie(cName) {
  const name = cName + "=";
  const cDecoded = decodeURIComponent(document.cookie); //to be careful
  const cArr = cDecoded.split("; ");
  let res;
  cArr.forEach((val) => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  });
  return res;
}

if (!Shopify.designMode) {
  // let's set a cookie for staff using query string if they need to avoid redirect
  if (window.location.href.indexOf("?staff") > 0) {
    setCookie("staff", true, 365);
  }

  // redirect management - here we redirect all users
  const countryLocation = window.Shopify.country;
  const isStaff = getCookie("staff");
  const redirectArray = ["US", "CA", "MX"];
  // check if location is in array of countries
 // console.log(countryLocation)
  if (redirectArray.includes(countryLocation)) {
    // no country matches - redirect to usaSite
    if (!isStaff || isStaff == undefined) {
     // window.location.href = usaSite;
    }
  }
}